var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import merge from 'lodash.merge';
import useDesign from '../../../hooks/useDesign';
import { BaseButton } from '../../atoms/BaseButton';
import { TranslatedText } from '../../atoms/TranslatedText';
import * as ButtonContent from './ButtonContent';
export var Button = function (_a) {
    var _b;
    var design = _a.design, active = _a.active, disabled = _a.disabled, error = _a.error, _c = _a.type, type = _c === void 0 ? 'button' : _c, props = __rest(_a, ["design", "active", "disabled", "error", "type"]);
    var _d = useDesign(design), config = _d.config, components = _d.components;
    var text = merge({}, config, props).text;
    var isSimpleTextButton = text || components.text;
    return (_jsx(BaseButton, __assign({ design: design, type: type, disabled: disabled, error: error, active: active }, props, { children: isSimpleTextButton ? (_jsx(TranslatedText, { design: components.text, i18n: text })) : ((_b = config === null || config === void 0 ? void 0 : config.content) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
            var compName = _a[0], compDesign = _a[1];
            var Component = ButtonContent[compName];
            return (_jsx(Component, { design: compDesign, disabled: disabled, error: error, active: active }, compDesign));
        })) })));
};
Button.displayName = 'Button';
export * from './Button.types';
